import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectHelpMedioPago } from 'sharedComponents/select-help'

import { KeyEventUtil } from 'utils'

const MedioPagoFormGroup = ({ iValue, iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-entregaARenidr-numeroDocumentoPago', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MEDIO PAGO' htmlFor='select-entregaARenidr-medioPago' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='medioPago'>
          {({ field }) => (
            <SelectHelpMedioPago
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              inputId='select-entregaARenidr-medioPago'
              selectId='select-entregaARenidr-medioPago'
              onInputKeyDown={onKeyDown}
              onSelectKeyDown={onKeyDown}
              iValue={iValue}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MedioPagoFormGroup)
